// eslint-disable-next-line
import React from 'react';
import {
  FaHtml5,
  FaCss3Alt,
  FaBootstrap,
  FaNodeJs,
  FaReact,
  FaGithubSquare,
  FaLinkedin,
  FaTwitterSquare,
} from 'react-icons/fa';
import {
  SiJavascript,
  SiTypescript,
  SiTailwindcss,
  SiGithub,
  SiGit,
  SiRedux,
} from 'react-icons/si';
import { TbBrandReactNative } from 'react-icons/tb';

function Home() {
  return (
    <div className="body">
      <div className="social-links-sm">
        <a
          href="https://github.com/srishti-maurya"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaGithubSquare size={25} />
        </a>
        <a
          href="https://www.linkedin.com/in/mauryasrishti22/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaLinkedin size={25} />
        </a>
        <a
          href="https://twitter.com/SrishtiMaurya1?s=09"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaTwitterSquare size={25} />
        </a>
      </div>
      <div className="division-1">
        <img src="./images/user1.png" className="coding" alt="coding-img" />
        <div className="margin-md">
          <h3 className="a">Hi, my name is</h3>
          <h1 className="heading-name">Srishti Maurya.</h1>
          <h1 className="heading-desc">
            Crafting intuitive and high-performing mobile experiences.
          </h1>
        </div>
      </div>
      <div className="division-2">
        <img src="./images/blob1.png" className="blob1" alt="coding-img" />
        <img src="./images/blob2.png" className="blob2" alt="coding-img" />
        <p className="text-md">
          Few technologies I’ve been working with recently
        </p>
        <div className="icons">
          <span title="HTML">
            <FaHtml5 size={60} />
          </span>
          <span title="CSS">
            <FaCss3Alt size={60} />
          </span>
          <span title="Javascript">
            <SiJavascript size={60} />
          </span>
          <span title="Typescript">
            <SiTypescript size={60} />
          </span>
          <span title="Bootstrap">
            <FaBootstrap size={60} />
          </span>
          <span title="Tailwind">
            <SiTailwindcss size={60} />
          </span>
          <span title="Git">
            <SiGit size={60} />
          </span>
          <span title="GitHub">
            <SiGithub size={60} />
          </span>
          <span title="NodeJS">
            <FaNodeJs size={60} />
          </span>
          <span title="React">
            <FaReact size={60} />
          </span>
          <span title="Redux">
            <SiRedux size={60} />
          </span>
          <span title="React Native">
            <TbBrandReactNative size={60} />
          </span>
        </div>
      </div>
      <div className="division-3">
        <div className="img-container-sm">
          <img src="./images/user2.png" className="coding" alt="coding-img" />
        </div>
        <div>
          <h5 className="heading-collab">Get In Touch</h5>
          <p className="content">
            Feel free to connect with me <br />
            <a href="mailto:mauryasrishti2209@gmail.com" className="mail-link">
              Start a conversation
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Home;
